import * as PIXI from "pixi.js";
import data from "./configs/data";
import {Button} from "./controlElements/Button";

export class BetsAreasPanel extends PIXI.Container {

    private leftAreaButton: Button;
    private centerAreaButton: Button;
    private rightAreaButton: Button;

    private readonly LEFT_AREA_BUTTON_POSITION = new PIXI.Point(179, 362);
    private readonly CENTER_AREA_BUTTON_POSITION = new PIXI.Point(640, 495);
    private readonly RIGHT_AREA_BUTTON_POSITION = new PIXI.Point(1103, 361);

    constructor() {
        super();
        this.createAndAddLeftBetArea();
        this.createAndAddCenterBetArea();
        this.createAndAddRightBetArea();
    }

    public disable(): void {
        this.leftAreaButton.enabled = false;
        this.centerAreaButton.enabled = false;
        this.rightAreaButton.enabled = false;
        this.leftAreaButton.cursor = "default";
        this.centerAreaButton.cursor = "default";
        this.rightAreaButton.cursor = "default";
    }

    public enable(): void {
        this.leftAreaButton.enabled = true;
        this.centerAreaButton.enabled = true;
        this.rightAreaButton.enabled = true;
        this.leftAreaButton.cursor = "pointer";
        this.centerAreaButton.cursor = "pointer";
        this.rightAreaButton.cursor = "pointer";
    }

    public addOnLeftAreaClickedListener(listener: Function): void {
        this.leftAreaButton.subscribeOnClicked(listener);
    }

    public addOnCenterAreaClickedListener(listener: Function): void {
        this.centerAreaButton.subscribeOnClicked(listener);
    }

    public addOnRightAreaClickedListener(listener: Function): void {
        this.rightAreaButton.subscribeOnClicked(listener);
    }

    private createAndAddLeftBetArea(): void {
        this.leftAreaButton = new Button(data.images.leftBetAreaButtonBase, data.images.leftBetAreaButtonHover,
            data.images.leftBetAreaButtonHover, data.images.leftBetAreaButtonBase, data.audios.buttonClicked);
        this.leftAreaButton.position = this.LEFT_AREA_BUTTON_POSITION;
        this.addChild(this.leftAreaButton);
    }

    private createAndAddCenterBetArea(): void {
        this.centerAreaButton = new Button(data.images.centerBetAreaButtonBase, data.images.centerBetAreaButtonHover,
            data.images.centerBetAreaButtonHover, data.images.centerBetAreaButtonBase, data.audios.buttonClicked);
        this.centerAreaButton.position = this.CENTER_AREA_BUTTON_POSITION;
        this.addChild(this.centerAreaButton);
    }

    private createAndAddRightBetArea(): void {
        this.rightAreaButton = new Button(data.images.rightBetAreaButtonBase, data.images.rightBetAreaButtonHover,
            data.images.rightBetAreaButtonHover, data.images.rightBetAreaButtonBase, data.audios.buttonClicked);
        this.rightAreaButton.position = this.RIGHT_AREA_BUTTON_POSITION;
        this.addChild(this.rightAreaButton);
    }
}



// WEBPACK FOOTER //
// ./src/app/BetsAreasPanel.ts